import type { TimelineItem as TimelineItemType } from "@tellescope/tanstack-query";
import { CallTimelineCard } from "./phone_calls/CallTimelineCard";
import { ChatRoomTimelineCard } from "./chat_rooms/ChatRoomTimelineCard";
import { EmailTimelineCard } from "./emails/EmailTimelineCard";
import { SMSMessageTimelineCard } from "./sms_messages/SMSMessageTimelineCard";
import { FormResponseTimelineCard } from "./form_responses/FormResponseTimelineCard";

export interface TimelineItemProps {
  currentEnduserId: string;
  enduserName: string;
  item: TimelineItemType;
  className?: string;
  /**
   * Controlled expanded state. Lifted to the block (above the virtualized list) so a card's
   * expanded/collapsed state survives being unmounted when scrolled off-screen. Optional — cards
   * fall back to local state when omitted (e.g. the legacy timeline).
   */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const TimelineItem = ({ item, ...rest }: TimelineItemProps) => {
  switch (item._type) {
    case "phone_call":
      return <CallTimelineCard item={item} callId={item.id} {...rest} />;
    case "form_response_group":
      return <FormResponseTimelineCard item={item} {...rest} />;
    case "sms_message":
      return <SMSMessageTimelineCard item={item} {...rest} />;
    case "chat_room":
      return <ChatRoomTimelineCard item={item} {...rest} />;
    case "email":
      return <EmailTimelineCard item={item} {...rest} />;
  }

  return null;
};
